// Generated by CoffeeScript 2.7.0
var SettingsAdministrations;

import UserItem from 'trunks/vue/admin/components/libs/user_item.js';

import deleteAdministratorPopover from 'trunks/vue/admin/components/settings/settings_administrations/delete_administrator_popover.js';

import Actions from 'trunks/vue/admin/components/settings/settings_administrations/actions.js';

import EditActionsModal from 'trunks/vue/admin/components/settings/settings_administrations/edit_actions_modal.js';

import Paginator from 'trunks/vue/admin/components/paginator.js';

import ResponsiveItem from 'trunks/vue/admin/components/responsive_item.js';

export default SettingsAdministrations = Vue.extend({
  components: {
    'user-item': UserItem,
    'delete-administrator-popover': deleteAdministratorPopover,
    'paginator': Paginator,
    'Actions': Actions,
    'responsive-item': ResponsiveItem
  },
  props: {
    actionList: {
      type: Array
    }
  },
  data: function() {
    return {
      administrationsList: [],
      resources: '/admin/settings/administrations.json',
      actions: []
    };
  },
  computed: {
    headerOption: function() {
      return {
        user: '姓名',
        identifier: '识别码/手机号',
        action: '角色权限'
      };
    },
    operations: function() {
      return [
        {
          type: 'edit'
        },
        {
          type: 'delete'
        }
      ];
    }
  },
  template: `<div class="main-content-wrapper">
  <div class="main-content-top">
    <button class="adding-btn" @click="openAddModal">新增</button>
  </div>
  <div class="settings-wrapper">
    <div class="settings-administrations-list">
      <responsive-item v-for="administration in administrationsList"
                       :key="administration.id"
                       :item="administration"
                       :headers="headerOption"
                       :operations="operations">
        <template slot="cellInfo" slot-scope="{ attr }">
          <div class="user" v-if="attr === 'user'"">
            <user-item :user="administration.user"/>
          </div>
          <div class="identifier" v-if="attr === 'identifier'">
            <div class="slp-tooltip top" :data-title="getTooltip(administration)"></div>
            <div class="user-info text-ellipsis" >{{ administration.user.identifier }}/{{ administration.user.phone }}</div>
          </div>
          <div class="action" v-if="attr === 'action'">
            <Actions :initialActions="transferActions(administration.action_ids)"/>
          </div>
        </template>
        <template slot="operations">
          <button class="text-btn" @click="openEditModal(administration)">编辑</button>
          <delete-administrator-popover :administrator='administration'
                                        resources='/admin/administrations'
                                        @deletedAdministrator="deleteAdministrationFunc" />
        </template>
      </responsive-item>
    </div>
  </div>
  <paginator  :resourceUrl='resources'
              :initialPage='1'
              @dataReceived="dataReceived"
              ref='paginator' />
</div>`,
  mounted: function() {
    return this.$refs.paginator.go();
  },
  methods: {
    dataReceived: function(data, option) {
      this.administrationsList = data;
      this.currentPage = option.currentPage;
      if (this.administrationsList.length === 0 && this.currentPage > 1) {
        this.$refs.paginator.goPrevious();
      }
      if (this.$refs.listRef) {
        return this.$refs.listRef.list = this.administrationsList;
      }
    },
    getTooltip: function(listItem) {
      return `${listItem.user.identifier}/${listItem.user.phone}`;
    },
    transferActions: function(action_ids) {
      return _.filter(this.actionList, function(action) {
        return action_ids.includes(action.id);
      });
    },
    openAddModal: function() {
      return new EditActionsModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-actions-modal-container'),
        propsData: {
          actionList: this.actionList,
          title: '新增空间管理员',
          resourcesUrl: "/admin/settings/administrations",
          requestMethod: 'post',
          callback: (administration) => {
            return this.$refs.paginator.refresh();
          }
        }
      });
    },
    openEditModal: function(administration) {
      return new EditActionsModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-actions-modal-container'),
        propsData: {
          actionList: this.actionList,
          administration: administration,
          title: '编辑空间管理员',
          requestMethod: 'patch',
          resourcesUrl: `/admin/settings/administrations/${administration.id}`,
          callback: (administration) => {
            return this.$refs.paginator.refresh();
          }
        }
      });
    },
    deleteAdministrationFunc: function(administration) {
      this.administrationsList = _.reject(this.administrationsList, function(item) {
        return item.id === administration.is;
      });
      return this.$refs.paginator.refresh();
    }
  }
});
